module.exports = __webpack_public_path__ + "img/roboport-door-down.3ceef6f0.png";